module.exports = {
    test:'测试'
}


// WEBPACK FOOTER //
// ./src/i18n/lang/cn.js